import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Benefits() {
  const benefits = ['Dejar de adivinar si llegás a fin de mes', 'Entender realmente cuánto debés y cómo pagarlo', 'Reducir el estrés y la ansiedad por el dinero', 'Empezar a ahorrar gradualmente con un plan', 'Tomar decisiones financieras con calma y seguridad'];
  return <section className="py-20 bg-[#10b981]/5" data-id="element-14">
      <div className="container mx-auto px-4 md:px-6" data-id="element-15">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-[#10b981]/10" data-id="element-16">
          <div className="text-center mb-10" data-id="element-17">
            <h2 className="text-3xl font-bold text-stone-900 mb-4" data-id="element-18">
              ¿Qué vas a lograr con esta plantilla?
            </h2>
            <p className="text-stone-600" data-id="element-19">
              Más que una hoja de cálculo, es el primer paso hacia tu
              tranquilidad.
            </p>
          </div>

          <div className="space-y-4" data-id="element-20">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-4 p-4 rounded-xl hover:bg-stone-50 transition-colors" data-id="element-21">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#10b981] flex items-center justify-center" data-id="element-22">
                  <Check className="w-5 h-5 text-white" data-id="element-23" />
                </div>
                <span className="text-lg font-medium text-stone-800" data-id="element-24">
                  {benefit}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}